export default __webpack_public_path__ + "static/media/bigsheep.70c178d7.jpg";